<template>
  <div class="title-wrap">
    <img
      id="a-titleimage"
      :src="require('@/assets/Nelson_Logo_RGB_400x90.png')"
      class="logo"
    />
    <div id="a-titleLabel" class="rotator-title">
      {{ Title }}
    </div>
    <div id="a-versionLabel" class="rotator-version">v {{ this.$version }}</div>
  </div>
</template>
<script>
export default {
  computed: {
    Title () {
      return process.env.VUE_APP_TITLE;
    },
  },
  components: {},
};
</script>

<style scoped>
.logo {
  height: 30px;
  width: auto;
  padding: 6px;
}
.rotator-title {
  font-size: 30px;
  font-family: Helvetica, Arial, sans-serif;
  color: #00ccff;
  font-weight: 400;
  vertical-align: bottom;
  margin-top: 5px;
  margin-left: 10px;
}
.registration-mark {
  color: #006ba6;
  margin-left: 2px;
}
.title-wrap {
  display: flex;
  align-items: last center;
}
.rotator-version {
  color: #509e2f;
  margin-left: 5px;
}
</style>